import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/AuthContext";
import { LoadingScreen } from "@/components/common/LoadingScreen";
import { ROUTES } from "@/constants/routes";
import { homeForRole } from "@/features/auth/roles";

/**
 * Guard for customer-only pages (checkout, profile, orders).
 *
 * - Unauthenticated  → /login (customer portal), preserves target via state
 * - Authenticated non-customer → their own dashboard (strict role isolation)
 * - Customer         → renders
 */
export function ProtectedRoute() {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return <LoadingScreen label="Checking your session…" />;
    }

    if (status !== "authenticated" || !user) {
        return (
            <Navigate
                to={ROUTES.login}
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    if (user.role !== "customer") {
        // Send them to *their* home, never to customer flow.
        return <Navigate to={homeForRole(user.role)} replace />;
    }

    return <Outlet />;
}

export default ProtectedRoute;
